import { createRouter } from "@tanstack/react-router";
/**
 * createAppRouter applies the defaults all three portals share.
 *
 * `defaultPreload: "intent"` starts a route's loader on hover, which is free
 * for a read-only page and is the difference between a portal that feels
 * instant and one that flashes a spinner on every navigation.
 */
export function createAppRouter(options) {
    return createRouter({
        routeTree: options.routeTree,
        context: options.context,
        basepath: options.basepath,
        defaultPreload: "intent",
        // 0 rather than a window: the loaders read through TanStack Query, which
        // is already deduplicating and caching. A second staleness rule here
        // would just be a second answer to the same question.
        defaultPreloadStaleTime: 0,
        scrollRestoration: true,
    });
}
//# sourceMappingURL=router.js.map